/** UI sizes subtracted from the window to find the canvas's available space. */
export interface CanvasInsets {
	sidebarWidth: number;
	weaponBarHeight: number;
	healthBarHeight: number;
	canvasBottomMargin: number;
}

export interface CanvasLayout {
	cssWidth: number;
	cssHeight: number;
	cellSize: number;
}

export function calculateCellSize(
	boardWidth: number,
	boardHeight: number,
	viewportWidth: number,
	viewportHeight: number,
): number {
	return Math.floor(Math.min(viewportWidth / boardWidth, viewportHeight / boardHeight));
}

// `capToBoardWidth` sizes the canvas to the board's exact width so the page can center it; skipped in
// camera-follow mode, where a narrower canvas would clip the player-centered view.
export function computeCanvasLayout(
	boardWidth: number,
	boardHeight: number,
	ratio: number,
	insets: CanvasInsets,
	capToBoardWidth: boolean,
): CanvasLayout {
	const availWidth = window.innerWidth - insets.sidebarWidth;
	const availHeight =
		window.innerHeight - insets.weaponBarHeight - insets.healthBarHeight - insets.canvasBottomMargin;
	const cellSize = calculateCellSize(
		boardWidth,
		boardHeight,
		Math.round(availWidth * ratio),
		Math.round(availHeight * ratio),
	);
	const boardCssWidth = (boardWidth * cellSize) / ratio;
	const cssWidth = capToBoardWidth ? Math.min(availWidth, boardCssWidth) : availWidth;
	return { cssWidth, cssHeight: availHeight, cellSize };
}
